import { Button, Col, DatePicker, Form, Modal, Row, Select } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FC } from 'react'
import StampOrder from '../../../../../types/api/stamp-order'
import { stampOrderOrderStatuses } from '../../../../../constants/entity-enums/stamp-order-order-statuses'
import { useUpdateStampOrderMutation } from '../../../../../store/api/stamp-orders-api'
import FormValues from './types/form-values'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { StrapiUpdate } from '../../../../../types/strapi/strapi'
import { outputDateFormat } from '../../../../../constants/constants'

interface GroupOperationsFormProps {
    stampOrders: StampOrder[]
    onSuccess: () => void
}

const GroupOperationsForm: FC<GroupOperationsFormProps> = ({ stampOrders, onSuccess }) => {
    const [form] = useForm()
    const [updateStampOrder, state] = useUpdateStampOrderMutation()

    const getUpdateQueryArg = (stampOrder: StampOrder) => {
        const values = form.getFieldsValue() as FormValues

        const data: StrapiUpdate<StampOrder>['body']['data'] = {}

        if (values.orderStatus) {
            data.orderStatus = values.orderStatus
        }

        if (values.orderStatus === 'Завершен') {
            data.quantity = 1
        }

        if (values.estimatedDate) {
            data.estimatedDate = values.estimatedDate.toISOString()
        }

        return {
            docId: stampOrder.documentId,
            body: {
                data,
            },
        }
    }

    const onSave = async () => {
        // TODO: Лучше сделать обновление одним запросом, создать контроллер и использовать bulk operations
        try {
            await form.validateFields()

            const promises = stampOrders.map(stampOrder => {
                const queryArg = getUpdateQueryArg(stampOrder)
                return updateStampOrder(queryArg)
            })

            const results = await Promise.all(promises)
            const allResultsIsSuccess = results.every(result => 'data' in result)

            if (allResultsIsSuccess) {
                form.resetFields()
                onSuccess()
                Modal.success({ title: 'Сохранено', content: 'Заказы штампов успешно обновлены' })
            }
        } catch (e) {
            console.error(e)
        }
    }

    useErrorModal(state, 'Ошибка при обновлении заказа штампа')

    return (
        <Form form={form} layout={'vertical'}>
            <br />

            <Row gutter={12}>
                <Col sm={7}>
                    <Form.Item name={'estimatedDate'} label={'Ожидаемая дата отгрузки'}>
                        <DatePicker format={outputDateFormat} />
                    </Form.Item>
                </Col>
                <Col sm={6}>
                    <Form.Item name={'orderStatus'} label={'Статус заказа'}>
                        <Select options={stampOrderOrderStatuses.map(item => ({ value: item }))} />
                    </Form.Item>
                </Col>
            </Row>

            <Button type={'primary'} loading={state.isLoading} onClick={onSave}>
                Сохранить
            </Button>
        </Form>
    )
}

export default GroupOperationsForm
